// extracted by mini-css-extract-plugin
export default {"root":"Manufacturer_root__aKGV9","header":"Manufacturer_header__qVFaC","body":"Manufacturer_body__RcoQb"};